window.SelectMenu = window.SelectMenu || {
  init: function (uid, config) {
    const {
      currentValue: initialValue = "",
      paramName = "select",
      storageKey = "",
      useUrlParams = false,
      useLocalStorage = false,
      onChange = null,
      iconCheck = "",
    } = config;

    const container = document.querySelector(".select-container-" + uid);
    if (!container) return;

    const button = container.querySelector('[data-select-button="' + uid + '"]');
    const display = container.querySelector('[data-select-display="' + uid + '"]');
    const icon = container.querySelector('[data-select-icon="' + uid + '"]');
    const listbox = container.querySelector('[data-select-listbox="' + uid + '"]');
    const input = container.querySelector('[data-select-input="' + uid + '"]');
    const options = Array.from(listbox.querySelectorAll('[role="option"]'));

    let isOpen = false;
    let focusedIndex = -1;
    let currentValue = initialValue;
    let searchString = "";
    let searchTimeout = null;

    // Restore from URL params / localStorage on load
    if (useUrlParams || useLocalStorage) {
      const urlParams = new URLSearchParams(window.location.search);
      const urlValue = useUrlParams ? urlParams.get(paramName) : null;
      const savedValue = useLocalStorage ? siteStorage.get(storageKey) : null;

      const hasInternalReferrer =
        document.referrer && document.referrer.includes(window.location.origin);
      const isInternalNavigation =
        sessionStorage.getItem("internal_navigation") === "true";
      const isExternalNavigation = !hasInternalReferrer && !isInternalNavigation;

      let effectiveValue;
      if (isExternalNavigation) {
        effectiveValue = urlValue;
      } else {
        if (urlValue && savedValue && urlValue !== savedValue) {
          effectiveValue = urlValue;
          if (useLocalStorage) siteStorage.set(storageKey, urlValue);
        } else {
          effectiveValue = savedValue || urlValue;
        }
      }

      if (effectiveValue && effectiveValue !== currentValue) {
        selectByCode(effectiveValue, false);
        if (useUrlParams && effectiveValue !== urlValue) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set(paramName, effectiveValue);
          newUrl.searchParams.set("page", "1");
          window.history.replaceState({}, "", newUrl.toString());
        }
      }

      sessionStorage.removeItem("internal_navigation");
    }

    function openDropdown() {
      if (isOpen) return;
      isOpen = true;
      listbox.classList.remove("hidden");
      button.setAttribute("aria-expanded", "true");
      if (icon) icon.classList.add("rotate-180");
      if (currentValue) {
        const idx = options.findIndex(
          (o) => o.dataset.optionCode === currentValue,
        );
        focusedIndex = idx >= 0 ? idx : 0;
      } else {
        focusedIndex = 0;
      }
      updateFocusedOption();
    }

    function closeDropdown(returnFocus) {
      if (!isOpen) return;
      isOpen = false;
      listbox.classList.add("hidden");
      button.setAttribute("aria-expanded", "false");
      if (icon) icon.classList.remove("rotate-180");
      focusedIndex = -1;
      clearFocusedOption();
      if (returnFocus !== false) button.focus();
    }

    function updateFocusedOption() {
      options.forEach((opt, i) => {
        const isSelected = opt.dataset.optionCode === currentValue;
        if (i === focusedIndex) {
          opt.classList.add("bg-primary", "text-primary-foreground");
          opt.classList.remove("text-text-primary");
          opt.scrollIntoView({ block: "nearest" });
        } else if (isSelected) {
          opt.classList.add("bg-primary", "text-primary-foreground");
          opt.classList.remove("text-text-primary");
        } else {
          opt.classList.remove("bg-primary", "text-primary-foreground");
          opt.classList.add("text-text-primary");
        }
      });
    }

    function clearFocusedOption() {
      options.forEach((opt) => {
        if (opt.dataset.optionCode !== currentValue) {
          opt.classList.remove("bg-primary", "text-primary-foreground");
          opt.classList.add("text-text-primary");
        }
      });
    }

    function selectOption(index) {
      const opt = options[index];
      if (!opt) return;
      selectByCode(opt.dataset.optionCode, true);
      closeDropdown();
    }

    function selectByCode(code, triggerChange) {
      const opt = options.find((o) => o.dataset.optionCode === code);
      if (!opt) return;

      options.forEach((o) => {
        o.classList.remove("bg-primary", "text-primary-foreground");
        o.classList.add("text-text-primary");
        o.setAttribute("aria-selected", "false");
        const existing = o.querySelector(".check-icon");
        if (existing) existing.remove();
      });

      opt.classList.add("bg-primary", "text-primary-foreground");
      opt.classList.remove("text-text-primary");
      opt.setAttribute("aria-selected", "true");

      if (!opt.querySelector(".check-icon")) {
        const checkIcon = document.createElement("span");
        checkIcon.className =
          "icon check-icon inline-flex items-center justify-center ml-2 flex-shrink-0";
        checkIcon.setAttribute("aria-hidden", "true");
        checkIcon.style.cssText =
          "width:var(--text-body,1rem);height:var(--text-body,1rem)";
        checkIcon.innerHTML = iconCheck;
        opt.appendChild(checkIcon);
      }

      currentValue = code;
      display.textContent = opt.dataset.optionDisplay;
      display.classList.remove("text-text-secondary");
      input.value = code;

      if (triggerChange) {
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
        if (useLocalStorage) {
          siteStorage.set(storageKey, code);
          sessionStorage.setItem("internal_navigation", "true");
        }
        if (onChange) {
          setTimeout(function () {
            try {
              onChange(code);
            } catch (error) {
              console.error("[SelectMenu] Error in on_change:", error);
            }
          }, 10);
        }
      }
    }

    function handleTypeAhead(char) {
      if (searchTimeout) clearTimeout(searchTimeout);
      searchString += char.toLowerCase();
      searchTimeout = setTimeout(function () {
        searchString = "";
      }, 500);
      if (!isOpen) openDropdown();
      const startIndex = (focusedIndex + 1) % options.length;
      for (let i = 0; i < options.length; i++) {
        const idx = (startIndex + i) % options.length;
        if (
          options[idx].dataset.optionDisplay
            .toLowerCase()
            .startsWith(searchString)
        ) {
          focusedIndex = idx;
          updateFocusedOption();
          return;
        }
      }
    }

    button.addEventListener("focus", () => button.classList.add("focus-visible"));
    button.addEventListener("blur", () => button.classList.remove("focus-visible"));
    button.addEventListener("click", (e) => { e.preventDefault(); isOpen ? closeDropdown() : openDropdown(); });

    button.addEventListener("keydown", function (e) {
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          if (!isOpen) { openDropdown(); } else { focusedIndex = Math.min(focusedIndex + 1, options.length - 1); updateFocusedOption(); }
          break;
        case "ArrowUp":
          e.preventDefault();
          if (!isOpen) { openDropdown(); } else { focusedIndex = Math.max(focusedIndex - 1, 0); updateFocusedOption(); }
          break;
        case "Enter":
        case " ":
          e.preventDefault();
          if (!isOpen) { openDropdown(); } else if (focusedIndex >= 0) { selectOption(focusedIndex); }
          break;
        case "Escape":
          e.preventDefault();
          closeDropdown();
          break;
        case "Tab":
          closeDropdown(false);
          break;
        case "Home":
          e.preventDefault();
          if (isOpen) { focusedIndex = 0; updateFocusedOption(); }
          break;
        case "End":
          e.preventDefault();
          if (isOpen) { focusedIndex = options.length - 1; updateFocusedOption(); }
          break;
        default:
          if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
            handleTypeAhead(e.key);
          }
      }
    });

    options.forEach(function (opt, index) {
      opt.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); selectOption(index); });
      opt.addEventListener("mouseenter", function () { focusedIndex = index; updateFocusedOption(); });
      opt.addEventListener("mouseleave", function () {
        if (opt.dataset.optionCode !== currentValue) {
          opt.classList.remove("bg-primary", "text-primary-foreground");
          opt.classList.add("text-text-primary");
        }
      });
    });

    document.addEventListener("click", function (e) {
      if (!container.contains(e.target)) closeDropdown(false);
    });
  },
};
